import { render } from "./StudyPhaseManagement.vue?vue&type=template&id=14a0f365&scoped=true"
import script from "./StudyPhaseManagement.js?vue&type=script&lang=js"
export * from "./StudyPhaseManagement.js?vue&type=script&lang=js"

import "./StudyPhaseManagement.vue?vue&type=style&index=0&id=14a0f365&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a0f365"]])

export default __exports__